import { render, staticRenderFns } from "./effectComparison.vue?vue&type=template&id=1d6baaff&scoped=true"
import script from "./effectComparison.vue?vue&type=script&lang=js"
export * from "./effectComparison.vue?vue&type=script&lang=js"
import style0 from "./effectComparison.vue?vue&type=style&index=0&id=1d6baaff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6baaff",
  null
  
)

export default component.exports